import React from 'react';
import { FaClipboardCheck, FaDownload } from 'react-icons/fa';
// import { useHistory } from 'react-router-dom';
import Card from '~/Components/Card';
import { Content, Header, CardsContainer } from './styles';
import { COLORS } from '~/styles/colors';
import Footer from '~/Components/Footer';

function AprovacaoDeParcelamentosDoSoloUrbano() {
	// const history = useHistory();
	return (
		<>
			<Content>
				<Header>Aprovação de Parcelamentos do Solo Urbano</Header>
				<p>Links úteis</p>
				<CardsContainer>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						href="http://www.prefeituradivinopolis.com.br/geoplantas/aprovacao_parcelamento/selo/"
						target="_blank"
						icon={
							<FaClipboardCheck size={48} color={COLORS.fgCard2}/>
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Selo de Projetos</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						href="http://www.prefeituradivinopolis.com.br/geoplantas/aprovacao_parcelamento/mapa/"
						target="_blank"
						icon={
							<FaDownload size={48} color={COLORS.fgCard2} />
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Mapa de localização</span>
							</span>
						}
					/>{/* 
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() => {
							history.push(
								'/media/aprovacao-de-projetos/parcelamentos-do-solo-urbano/selo-de-projetos'
							);
						}}
						target="_self"
						icon={
							<FaClipboardCheck
								size={48}
								color={COLORS.fgCard2}
							/>
						}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Selo de Projetos</span>
							</span>
						}
					/>
					<Card
						backgroundColor={COLORS.bgCard2}
						textColor={COLORS.fgCard2}
						onClick={() => {
							history.push(
								'/media/aprovacao-de-projetos/parcelamentos-do-solo-urbano/mapa-de-localizacao'
							);
						}}
						target="_self"
						icon={<FaDownload size={48} color={COLORS.fgCard2} />}
						text={
							<span
								style={{
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<span>Mapa de localização</span>
							</span>
						}
					/> */}
				</CardsContainer>
			</Content>
			<Footer />
		</>
	);
}

export default AprovacaoDeParcelamentosDoSoloUrbano;
